import { createSlice } from '@reduxjs/toolkit';
import { createSelectorFn } from './common';

const initialState = {
  loading: false
};

const appLoadingSlice = createSlice({
  name: 'appLoading',
  initialState,
  reducers: {
    setAppLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const { setAppLoading } = appLoadingSlice.actions;
export const useAppLoadingSliceSelector = createSelectorFn(appLoadingSlice);
export default appLoadingSlice;
